import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-business-web/';
export default {
  axios,
  getRemindList(params) {
    return axios.get(`${baseUrl}pharmaceuticalCare/goodsRemind/list?${utils.exchangeParams(params)}`);
  },
  newRemind(params) {
    return axios.post(`${baseUrl}pharmaceuticalCare/goodsRemind/add`, params, { headers: { 'Content-Type': 'application/json' } });
  },
  updateRemind(params) {
    return axios.post(`${baseUrl}pharmaceuticalCare/goodsRemind/edit`, params, { headers: { 'Content-Type': 'application/json' } });
  },
  deleteRemind(params) {
    return axios.get(`${baseUrl}pharmaceuticalCare/goodsRemind/del?${utils.exchangeParams(params)}`);
  },
  getRemindInfo(params) {
    return axios.get(`${baseUrl}pharmaceuticalCare/goodsRemind/info?${utils.exchangeParams(params)}`);
  },
  setRemindStatusEnable(params) {
    return axios.post(`${baseUrl}pharmaceuticalCare/goodsRemind/enable`, params, { headers: { 'Content-Type': 'application/json' } });
  },
  getGoodsList(params) {
    return axios.get(`v1/erp-base-web/goods/store/list?${utils.exchangeParams(params)}`);
  },
};
